<app-navbar
  [logoLightPath]="logo.light"
  [logoDarkPath]="logo.dark"
></app-navbar>
<div class="bgr-image" [class.hide-footer]="hideFooter">
  <div class="login-wrapper">
    <ix-typography class="pb-2" format="display-lg" id="loginPanelHeadline"
      >{{ 'login.panel_headline' | translate }}
    </ix-typography>
    <ix-typography class="pb-3" format="body-lg" id="loginBody">{{
      'login.body' | translate
      }}
    </ix-typography>
    <ix-button
      (click)="onLoginClick()"
      class="w-100"
      id="loginButton"
      onkeypress=""
      variant="primary"
      >{{ 'general.login' | translate }}
    </ix-button>
    <ix-typography class="pt-3" format="body"
      >{{ 'login.no_account' | translate }}
      <a (click)="onRegisterLinkClick()" class="link">{{
        'login.register' | translate
      }}</a>
    </ix-typography>

    <div class="divider my-4">{{ 'login.or' | translate }}</div>
    <app-search-battery-pass [isPublic]="true"></app-search-battery-pass>
  </div>
</div>
<app-footer></app-footer>

<ng-template #loginErrorModal let-modal>
  <div>
    <ix-modal-header>
      @switch (errorType) {
        @case ('noUser') {
          {{ 'login.errors.error_head_no_user' | translate }}
        }
        @case ('forbidden') {
          {{ 'login.errors.error_head_forbidden' | translate }}
        }
        @case ('unknown') {
          {{ 'login.errors.error_head_unknown' | translate }}
        }
        @case ('inactivityLogout') {
          {{ 'login.errors.error_head_inactivity_logout' | translate }}
        }
      }
      </ix-modal-header
      >
      <ix-modal-content>
        <ix-typography format="body">
          @switch (errorType) {
            @case ('noUser') {
              {{ 'login.errors.no_user' | translate }}
            }
            @case ('forbidden') {
              {{ 'login.errors.forbidden' | translate }}
            }
            @case ('unknown') {
              {{ 'login.errors.unknown' | translate }}
            }
            @case ('inactivityLogout') {
              {{ 'login.errors.inactivity_logout' | translate }}
            }
          }
        </ix-typography>
        <br/>
        <ix-typography format="body"
          >{{ 'login.errors.help_text' | translate }}
          <a
            class="link"
            href="{{ 'login.modal.link' | translate }}"
            rel="noopener"
            target="_blank"
            >{{ 'login.modal.link_text' | translate }}</a
            >
          </ix-typography>
        </ix-modal-content>
        <ix-modal-footer>
          <ix-button
            (click)="modal.close('okay')"
            class="close-modal"
            onkeypress=""
            variant="primary"
            >
            OK
          </ix-button>
        </ix-modal-footer>
      </div>
    </ng-template>
